interface FlightLeg {
  codeShare: boolean;
  legCode: string;
  legEntity: string;
  legRegion: string;
  segments: Segment[];
  selectedLeg: boolean;
  sdsProvider:string;
  serviceCodeShareEnable:boolean;
}

interface Segment {
  flightNumber: string;
  departure: string;
  arrival: string;
  duration: string;
  airline: string;
}

export class ViewDocuments {
  passengers: Passenger[];
  warnings: any[];
  bookedLegCollection:FlightLeg[];

  reservationCode: string
  travelPartyId: string;
  tripType: string;
  mandates: Mandate[];
  trips: Trip[];
  links: Links;

  constructor(obj) {
    this.passengers = obj.passengers.map(passenger => new Passenger(passenger));
    this.bookedLegCollection = obj?.bookedLegCollection;
    this.travelPartyId = obj.travelPartyId;
    this.tripType = obj.tripType;
    this.mandates = obj.mandates;
    this.trips = obj.trips;
    this.links = obj.links;
  }
}

export class Passenger {
  selectedForCheckin: boolean;
  birthDate: string;
  firstName: string;
  freeTextInfoList: FreeTextInfoList[];
  gender: string;
  type: string;
  lastName: string;
  missingCheckinOptionalFields: string[];
  missingCheckinRequiredFields: MissingCheckinRequiredFields[];
  passengerIds: PassengerIds[];
  passengerNameNumber: string;
  requiredInfoList: RequiredInfoList[];
  timaticInfoList:any;
  timaticRQ:any
  passengerIdSkyteam?: string;
  checkinStatus:string;
  destinationAddress: any;
  contactEmergency: any;
  passport: any;
  residenceAddress: any;
  visa: any;
  countryResidence: any;
  sprinklr: boolean;
  sourceMissing: string;

  constructor(passenger:any) {
    this.selectedForCheckin = passenger?.selectedForCheckin;
    this.firstName = passenger?.firstName;
    this.lastName = passenger?.lastName;
    this.passengerNameNumber = passenger?.passengerNameNumber;
    this.gender = passenger?.gender;
    this.type = passenger?.type;
    this.birthDate = passenger?.birthDate;
    this.sourceMissing = passenger?.sourceMissing;
    this.sprinklr = passenger?.sprinklr;
    this.missingCheckinOptionalFields = passenger?.missingCheckinOptionalFields;
    this.missingCheckinRequiredFields = passenger?.missingCheckinRequiredFields.map( (missing: MissingCheckinRequiredFields)  => new MissingCheckinRequiredFields(missing));
    this.passengerIds = passenger?.passengerIds?.map( (passengerId: PassengerIds )  => new PassengerIds(passengerId)) ?? [];
    this.requiredInfoList = passenger?.requiredInfoList?.map( (required: RequiredInfoList )  => new RequiredInfoList(required)) ?? [];
    this.freeTextInfoList = passenger?.freeTextInfoList?.map( (textInfo: FreeTextInfoList )  => new FreeTextInfoList(textInfo)) ?? [];
    this.timaticInfoList = passenger?.timaticInfoList
    this.timaticRQ = passenger?.timaticRQ
    this.passengerIdSkyteam = passenger?.passengerIdSkyteam;

    this.checkinStatus = passenger?.checkinStatus;
    this.destinationAddress = passenger?.destinationAddress;
    this.contactEmergency = passenger?.contactEmergency;
    this.passport = this.getPassport(passenger?.passport);
    this.residenceAddress = passenger?.residenceAddress;
    this.visa = passenger?.visa;
    this.countryResidence = passenger?.countryOfResidence;
  }

  getPassport(passport:any) {
    return {
      expirationDate: passport?.expirationDate,
      issueCountry: passport?.issueCountry,
      nationality: passport?.nationality,
      documentNumber: passport?.number,
      passportScanned: passport?.passportScanned,
    }
  }

}

export class PassengerIds {
  id: string
  segmentCode: string

  constructor(passenger:any) {
    this.id = passenger?.id;
    this.segmentCode = passenger?.segmentCode;
  }
}

export class RequiredInfoList {
  code: string
  freeText: string

  constructor(required:any) {
    this.code = required?.code;
    this.freeText = required?.freeText;
  }
}

export class FreeTextInfoList {
  editCode: string
  text: string

  constructor(freetext:any) {
    this.editCode = freetext?.editCode;
    this.text = freetext?.text;
  }
}

export class MissingCheckinRequiredFields {
  title: string;
  preview: string;
  document: string;
  status: boolean;
  isRequired: boolean;
  textButton: string;
  infant:boolean;
  save:boolean;
  constructor(file:any) {
    this.title = file;
    this.preview = "";
    this.document = file;
    this.status = false;
    this.isRequired = true;
    this.textButton = '';
    this.save = false;
  }
}

export class Mandate {
  code: string
  confirmed: boolean
  description: string
  groupType: string
  id: string
}

export class Trip{
  id: string
  ordinal: number
}

export class Links {
  passengerInformation: PassengerInformation
  checkinWeb: CheckinWeb
  checkinMobile: CheckinMobile
  self: Self
}

export class PassengerInformation {
  href: string
}

export class CheckinWeb {
  href: string
}

export class CheckinMobile {
  href: string
}

export class Self {
  href: string
}
